// extracted by mini-css-extract-plugin
export default {"wrapper":"FolderWrapper_wrapper__-Z+mF"};